import { BaseService } from '@services/BaseService'

const resource = 'hr/medication'

class MedicationService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const medicationService = new MedicationService()
